import { compose } from "redux";

const environment = "production";
// const environment = "development";

const PAYSTACK_PUBLIC_KEY =
  environment === "production"
    ? "pk_live_cb0fba9e6f3b49fb4285571326d11e51b924a8f4"
    : "pk_test_af91df84565095d59cdfb8868d0e7741e5bb19ff";

const firebaseConfig =
  environment === "production"
    ? {
        apiKey: "AIzaSyBUQs-C3DV8iZ_NYSdjHN--g50yMETXXMY",
        authDomain: "easychaw-2329c.firebaseapp.com",
        databaseURL: "https://easychaw-2329c.firebaseio.com",
        projectId: "easychaw-2329c",
        storageBucket: "easychaw-2329c.appspot.com",
        messagingSenderId: "444953583881",
        appId: "1:444953583881:web:102ca13afbf5bb99c7f3d8",
        measurementId: "G-6SZKWLW89M",
      }
    : {
        apiKey: "AIzaSyB10eXJUKuEv5i4lkv0rWeK3JrpveDHmOQ",
        authDomain: "test-easychaw.firebaseapp.com",
        databaseURL: "https://test-easychaw.firebaseio.com",
        projectId: "test-easychaw",
        storageBucket: "test-easychaw.appspot.com",
        messagingSenderId: "48327216064",
        appId: "1:48327216064:web:c01dae0d1d802e23451625",
        measurementId: "G-RPBP07KBKG",
      };

const firebaseRequestURI =
  environment === "production"
    ? "https://us-central1-easychaw-2329c.cloudfunctions.net"
    : "https://us-central1-test-easychaw.cloudfunctions.net";

const composeEnhancers =
  environment === "production"
    ? compose
    : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export {
  PAYSTACK_PUBLIC_KEY,
  firebaseConfig,
  firebaseRequestURI,
  composeEnhancers,
};
